// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".desktop-logo[data-v-2402be90]{height:70%;cursor:pointer}.mobile-logo[data-v-2402be90]{height:65%;cursor:pointer}.unvergessen-search-field[data-v-2402be90]{margin-right:15px}", ""]);
// Exports
module.exports = exports;
